import { IOfferCard } from '../../../../types';

export const prepareAvatarLink = ({ offerUser }: IOfferCard) => {
  if (!offerUser) {
    return;
  }

  if (offerUser.masterAgent) {
    return offerUser.masterAgent.absoluteAvatarUrl;
  }

  return offerUser.agentAvatarUrl;
};
